import { createAction, props } from "@ngrx/store";

import { CustomerType } from "../models/register-your-interest.models";

export const openRegisterYourInterest = createAction(
    "[RegisterYourInterest] Open Register-your-interest tray",
);

export const resetRegisterYourInterest = createAction(
    "[RegisterYourInterest] Reset Register-your-interest tray",
);

export const setCustomerType = createAction(
    "[RegisterYourInterest] Set customer type",
    props<{ customerType: CustomerType }>(),
);

export const resetCustomerType = createAction(
    "[RegisterYourInterest] Reset customer type",
);
